import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumStockReductionOption implements BaseEnumType {
  private static allValues: EnumStockReductionOption[] = []; // make sure this is top-most
  
  public static emptyUrn = new EnumStockReductionOption(0, "EmptyUrn", "enum_stock_reduction_option_empty_urn");
  public static deliveredUrn = new EnumStockReductionOption(1, "DeliveredUrn", "enum_stock_reduction_option_delivered_urn");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockReductionOption.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isEmptyUrn() { return this === EnumStockReductionOption.emptyUrn; }
  public isDeliveredUrn() { return this === EnumStockReductionOption.deliveredUrn; }

  public static getValues(): readonly EnumStockReductionOption[] {
    return EnumStockReductionOption.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockReductionOption[] {
    return EnumStockReductionOption.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockReductionOption {
    const found = EnumStockReductionOption.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockReductionOption - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockReductionOption): EnumStockReductionOption {
    const found = name ? EnumStockReductionOption.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockReductionOption - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumStockReductionOption>): boolean {
    return this.key === other?.key;
  }
}